module.exports = __webpack_public_path__ + "static/about_hero-3eb9443ce8c73879c08dea466b8f9a1c.png";